import cx from 'classnames';
import memoize from 'fast-memoize';
import {BasicElementProps} from "./layout/Group";
import {CSSProperties, ReactElement} from "react";

const ARRAY_STYLES = ['padding', 'margin'];

export function propsToCSS({style, 'class': classes, layout}: BasicElementProps): {
  className: string,
  style: CSSProperties
} {
  return process(style, classes, layout);
}

const process = memoize((style, classes, layout) => {

  if (classes && typeof classes !== 'string') {
    classes = cx(classes);
  }

  style = style ? {...style} : {};

  processArrayStyles(style);

  if (layout) {
    if (layout.flow) {
      style.display = 'flex';
      style.flexDirection = layout.flow === 'horizontal' ? 'row' : 'column' ;
    }
    if (layout.grow) {
      style.flexGrow = layout.grow;
    }
    if (layout.basis) {
      style.flexGrow = layout.basis;
    }
    if (layout.wrap) {
      style.flexWrap = layout.wrap;
    }
  }

  return {
    className: classes,
    style
  }
});

function processArrayStyles(style) {
  ARRAY_STYLES.forEach(styleName => {
    if (style[styleName]) {
      style[styleName] = coerceArrayStyle(style[styleName]);
    }
  });
}

function coerceArrayStyle(style) {
  if (Array.isArray(style)) {
    return style.map(coercePrimitiveStyle).join(' ');
  } else {
    return coercePrimitiveStyle(style)
  }
}

function coercePrimitiveStyle(style) {
  if (typeof style === 'string') {
    return style;
  } else {
    return style + 'px';
  }
}